import React, { Component } from "react";

export default class CompanyITR extends Component {
  constructor(props) {
    super(props);
    this.refs = {
      companyITRForm: React.createRef(),
    };
    this.state = {};
    this.divClasses = "col-12 col-md-6 col-xl-4 d-flex flex-wrap";
    // this.labelinputs = [
    //   {
    //     id: "saral_copy",
    //     label: "Saral Copy",
    //     years: [
    //       { year1: "Assessment Year 2022-23" },
    //       { year2: "Assessment Year 2021-22" },
    //       { year3: "Assessment Year 2020-21" },
    //     ],
    //   },
    //   {
    //     id: "compIncome",
    //     label: "Computation Of Income",
    //     years: [
    //       { year1: "Assessment Year 2022-23" },
    //       { year2: "Assessment Year 2021-22" },
    //       { year3: "Assessment Year 2020-21" },
    //     ],
    //   },
    //   {
    //     id: "auditorReport",
    //     label: "Auditors Report",
    //     years: [
    //       { year1: "Assessment Year 2022-23" },
    //       { year2: "Assessment Year 2021-22" },
    //       { year3: "Assessment Year 2020-21" },
    //     ],
    //   },
    //   {
    //     id: "plBlSchld",
    //     label: "P&L, Balance Sheet and Schedules",
    //     years: [
    //       { year1: "Assessment Year 2022-23" },
    //       { year2: "Assessment Year 2021-22" },
    //       { year3: "Assessment Year 2020-21" },
    //     ],
    //   },
    //   {
    //     id: "caCd",
    //     label: "3CA & 3CD",
    //     years: [
    //       { year1: "Assessment Year 2022-23" },
    //       { year1: "Assessment Year 2022-23" },
    //       { year1: "Assessment Year 2022-23" },
    //     ],
    //   },
    // ];
  }
  saveCompanyITR() {
    console.log(
      "saveCompanyITR values:",
      this.refs.companyITRForm.form.current.getData()
    );
  }
  render() {
    let { Tenor } = enums;
    return (
      <>
        <AppForm
          className="row mb-2"
          ref="companyITRForm"
          onSubmit={() => this.saveCompanyITR()}
        >
          <div className="row d-flex mb-0 g-3">
            <div className="col-12 col-md-2"></div>
            <div className="col-12 col-md-10 d-flex flex-wrap">
              <div className="container row mx-auto px-0">
                <div className="col-12 col-md-6 col-xl-4 d-flex flex-wrap">
                  <p className="mandatory">Assessment Year 2022-23</p>
                </div>
                <div className="col-12 col-md-6 col-xl-4 d-flex flex-wrap">
                  <p className="mandatory">Assessment Year 2021-22</p>
                </div>
                <div className="col-12 col-md-6 col-xl-4 d-flex flex-wrap">
                  <p className="mandatory">Assessment Year 2020-21</p>
                </div>
              </div>
            </div>
          </div>

          {/* {this.labelinputs.map((field, i) => {
            <div className="row d-flex mb-3 g-3" key={i}>
              <label htmlFor="test" className="col-12 col-md-2 col-form-label">
                {field.label}
              </label>
              <div className="col-12 col-md-10 d-flex flex-wrap">
                <div className="row mx-auto d-none">
                  <AppUploadPassword
                    inputName="saral_copy_year1"
                    outerclass={this.divClasses}
                    fileClass="custom_uploadbtn_outer"
                  />
                  <AppUploadPassword
                    inputName="saral_copy_year2"
                    outerclass={this.divClasses}
                    fileClass="custom_uploadbtn_outer"
                  />
                  <AppUploadPassword
                    inputName="saral_copy_year3"
                    outerclass={this.divClasses}
                    fileClass="custom_uploadbtn_outer"
                  />
                </div>
              </div>
            </div>;
          })} */}

          <div className="row d-flex mb-3 g-3">
            <label htmlFor="test" className="col-12 col-md-2 col-form-label">
              Complete ITR Return
            </label>
            <div className="col-12 col-md-10 d-flex flex-wrap">
              <div className="row mx-auto">
                <AppUploadPassword
                  inputName="saral_copy_year1"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
                <AppUploadPassword
                  inputName="saral_copy_year2"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
                <AppUploadPassword
                  inputName="saral_copy_year3"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
              </div>
            </div>
          </div>

          <div className="row d-flex mb-3 g-3">
            <label htmlFor="test" className="col-12 col-md-2 col-form-label">
              Computation Of Income
            </label>
            <div className="col-12 col-md-10 d-flex flex-wrap">
              <div className="row mx-auto">
                <AppUploadPassword
                  inputName="compIncome_year1"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
                <AppUploadPassword
                  inputName="compIncome_year2"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
                <AppUploadPassword
                  inputName="compIncome_year3"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
              </div>
            </div>
          </div>

          <div className="row d-flex mb-3 g-3">
            <label htmlFor="test" className="col-12 col-md-2 col-form-label">
              Auditors Report
            </label>
            <div className="col-12 col-md-10 d-flex flex-wrap">
              <div className="row mx-auto">
                <AppUploadPassword
                  inputName="auditorReport_year1"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
                <AppUploadPassword
                  inputName="auditorReport_year2"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
                <AppUploadPassword
                  inputName="auditorReport_year3"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
              </div>
            </div>
          </div>

          <div className="row d-flex mb-3 g-3">
            <label htmlFor="test" className="col-12 col-md-2 col-form-label">
              P&L, Balance Sheet and Schedules
            </label>
            <div className="col-12 col-md-10 d-flex flex-wrap">
              <div className="row mx-auto">
                <AppUploadPassword
                  inputName="plBlSchld_year1"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
                <AppUploadPassword
                  inputName="plBlSchld_year2"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
                <AppUploadPassword
                  inputName="plBlSchld_year3"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
              </div>
            </div>
          </div>

          <div className="row d-flex mb-3 g-3">
            <label htmlFor="test" className="col-12 col-md-2 col-form-label">
              3CA & 3CD
            </label>
            <div className="col-12 col-md-10 d-flex flex-wrap">
              <div className="row mx-auto">
                <AppUploadPassword
                  inputName="caCd_year1"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
                <AppUploadPassword
                  inputName="caCd_year2"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
                <AppUploadPassword
                  inputName="caCd_year3"
                  outerclass={this.divClasses}
                  fileClass="custom_uploadbtn_outer"
                  editaccess="false"
                />
              </div>
            </div>
          </div>

          <hr className="mb-5" />

          <div className="row d-flex mb-3 g-3">
            <label htmlFor="test" className="col-12 col-md-2 col-form-label">
              GSTR File
            </label>
            <div className="col-12 col-md-10">
              <div className="row">
                <div className="col">Tenor</div>
              </div>
              <div className="row">
                <div className="col-6 col-lg-3 col-xl-3">
                  <AppInput
                    type="select"
                    name="gstrFileTenor"
                    options={Tenor.options()}
                    //   value={item.snum}
                    //   onChange={(e) => onChange(index, e)}
                  />
                </div>
                <AppUploadPassword
                  outerclass="col-12 col-lg-6 d-flex flex-wrap"
                  editaccess="false"
                />
              </div>
            </div>
          </div>
          <div className="row mx-auto align-items-center mt-3">
            <div className="col-12">
              <button
                type="submit"
                className="btn add-btn grey ms-2 text-dark rounded-pill"
              >
                Submit
              </button>
              <button
                type="submit"
                className="btn add-btn btn-warning text-dark rounded-pill"
              >
                Save
              </button>
            </div>
          </div>
        </AppForm>
      </>
    );
  }
}